import { Box, CircularProgress } from '@mui/material';
import { useGetMe } from '@/lib/api/me.ts';
import InvestorHome from './InvestorHome.tsx';
import PsiHome from './PsiHome.tsx';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const { data: user } = useGetMe();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.role === 'investor') {
      navigate('/dashboard');
    }
  }, [navigate, user?.role]);

  if (!user) {
    return (
      <Box sx={{ p: 3, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  return user.role === 'investor' ? <InvestorHome /> : <PsiHome />;
}
